import { faWindowRestore } from "@fortawesome/pro-regular-svg-icons";
import { faWindowRestore as windowRestoreBold } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { togglePictureInPicture } from "redux/actions";

const showPictureInPictureSelector = (state) => state.showPictureInPicture;

const PictureInPictureButton = ({ isStills, popoverMountPointRef, sources }) => {
    const showPictureInPicture = useSelector(showPictureInPictureSelector);
    const [shouldShow, setShouldShow] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!sources) return;

        const stillsCount = sources.reduce((count, src) => {
            return count + src.streams.filter((s) => s.isStills).length;
        }, 0);

        if (stillsCount < 2) {
            setShouldShow(false);
            dispatch(togglePictureInPicture(false));
            return;
        }

        setShouldShow(true);
    }, [sources, showPictureInPicture, dispatch]);

    if (!isStills || !shouldShow) {
        return null;
    }

    return (
        <div className="VideoControls__Item">
            <Popover
                getPopupContainer={() => popoverMountPointRef.current}
                placement="top"
                content={!showPictureInPicture ? "Show picture in picture" : "Hide picture in picture"}>
                <FontAwesomeIcon
                    style={{ color: showPictureInPicture ? "white" : "inherit" }}
                    icon={showPictureInPicture ? windowRestoreBold : faWindowRestore}
                    onClick={() => {
                        dispatch(togglePictureInPicture(!showPictureInPicture));
                    }}
                />
            </Popover>
        </div>
    );
};

export default PictureInPictureButton;
